import React from "react";

function BS4_GetStarted() {
  return (
    <div>
      <h1>BS4_GetStarted Component</h1>
      <p>This is the BS4_GetStarted tutorial page content.</p>
    </div>
  );
}

export default BS4_GetStarted;
